/*
 * accessibility-widget.js — widget d'accessibilité site-wide (ticket 11393).
 *
 * v3 — calqué de près sur « Ally by Elementor » (référence maisonslacin.fr,
 * structure réelle inspectée : bouton 44px, panneau à en-tête accentué,
 * grille de tuiles à étapes, bottom-sheet mobile) et rendu GÉNÉRIQUE :
 * couleur d'accent, taille et position du bouton configurables par site,
 * contraste du texte de l'accent calculé automatiquement (luminance).
 *
 *   Profils  : Malvoyant, Dyslexie, Photosensible, Daltonisme, Concentration.
 *   Tuiles   : Texte plus grand (4 crans), Hauteur de ligne (3), Espacement,
 *              Alignement (2), Police lisible, Contraste (3), Saturation (2),
 *              Niveaux de gris, Masquer les images, Pause animations, Liens
 *              en évidence, Masque de lecture, Guide de lecture, Grand
 *              curseur, Focus renforcé — clic = cran suivant, points d'étape.
 *   Divers   : structure de la page (titres), plan du site, déclaration
 *              d'accessibilité, réinitialiser, masquer 24 h, Alt+A, FR/EN.
 *
 * Intégration : fichier autonome (CSS injecté) activé par la config émise
 * par SiteBodyEndContent :
 *   window.__pdA11yConfig = { enabled, mode, position, size, color,
 *                             statementUrl, sitemapUrl }
 *   mode "live"   → bouton flottant visible (défaut) ;
 *   mode "hidden" → PAS de bouton : le panneau reste accessible via Alt+A,
 *                   window.PdA11y.open() ou tout élément [data-pd-a11y]
 *                   (ex. lien « Accessibilité » dans le footer du site).
 *
 * Préférences localStorage (pd-a11y) réappliquées à chaque page. Panneau
 * accessible : role="dialog", aria-modal, piège de focus, Échap, tuiles
 * aria-pressed + valeur courante dans l'aria-label, annonces aria-live.
 * Jamais rendu sous /admin (config non émise).
 *
 * Notes d'implémentation (voir mémoire accessibility-widget) :
 * filter sur <html> ne casse pas les position:fixed (racine spéciale) ;
 * texte plus grand = zoom body + contre-zoom du widget ; display sur #id
 * bat la règle UA [hidden] → règles [hidden]{display:none!important}.
 */
(function () {
    'use strict';
    if (window.PdA11y) return;

    var KEY = 'pd-a11y';
    var HIDE_KEY = 'pd-a11y-hidden-until';
    var LANG_KEY = 'pd-a11y-lang';

    // ── i18n ──────────────────────────────────────────────────────────
    var STRINGS = {
        fr: {
            open: 'Ouvrir le menu d’accessibilité', title: 'Accessibilité', close: 'Fermer',
            profiles: 'Profils d’accessibilité',
            pVision: 'Malvoyant', pDyslexia: 'Dyslexie', pSeizure: 'Photosensible',
            pColorblind: 'Daltonisme', pAdhd: 'Concentration',
            text: 'Texte', bigger: 'Texte plus grand', lineHeight: 'Hauteur de ligne',
            spacing: 'Espacement du texte', align: 'Alignement du texte',
            alignLeft: 'gauche', alignRight: 'droite', font: 'Police lisible',
            visual: 'Visuel', contrast: 'Contraste', dark: 'sombre', light: 'clair', high: 'élevé',
            saturation: 'Saturation', satLow: 'faible', satHigh: 'élevée',
            gray: 'Niveaux de gris', noimg: 'Masquer les images', pause: 'Pause animations',
            orientation: 'Repères', links: 'Liens en évidence', mask: 'Masque de lecture',
            guide: 'Guide de lecture', cursor: 'Grand curseur', focus: 'Focus renforcé',
            structure: 'Structure de la page', structureEmpty: 'Aucun titre trouvé sur cette page.',
            sitemap: 'Plan du site', statement: 'Déclaration d’accessibilité',
            reset: 'Réinitialiser', hide: 'Masquer le widget', hideConfirm: 'Masquer 24 h ?',
            on: 'activé', off: 'désactivé', back: 'Retour aux réglages',
            shortcut: 'Alt+A', activeCount: 'réglages actifs',
        },
        en: {
            open: 'Open accessibility menu', title: 'Accessibility', close: 'Close',
            profiles: 'Accessibility profiles',
            pVision: 'Low vision', pDyslexia: 'Dyslexia', pSeizure: 'Seizure safe',
            pColorblind: 'Color blind', pAdhd: 'Focus',
            text: 'Text', bigger: 'Bigger text', lineHeight: 'Line height',
            spacing: 'Text spacing', align: 'Text alignment',
            alignLeft: 'left', alignRight: 'right', font: 'Readable font',
            visual: 'Visual', contrast: 'Contrast', dark: 'dark', light: 'light', high: 'high',
            saturation: 'Saturation', satLow: 'low', satHigh: 'high',
            gray: 'Grayscale', noimg: 'Hide images', pause: 'Pause animations',
            orientation: 'Orientation', links: 'Highlight links', mask: 'Reading mask',
            guide: 'Reading guide', cursor: 'Big cursor', focus: 'Strong focus',
            structure: 'Page structure', structureEmpty: 'No headings found on this page.',
            sitemap: 'Site map', statement: 'Accessibility statement',
            reset: 'Reset', hide: 'Hide widget', hideConfirm: 'Hide for 24 h?',
            on: 'on', off: 'off', back: 'Back to settings',
            shortcut: 'Alt+A', activeCount: 'active settings',
        },
    };

    function lang() {
        try {
            var stored = localStorage.getItem(LANG_KEY);
            if (stored === 'fr' || stored === 'en') return stored;
        } catch (e) { }
        return (document.documentElement.lang || 'fr').toLowerCase().indexOf('fr') === 0 ? 'fr' : 'en';
    }
    var T = STRINGS[lang()];

    // ── state ─────────────────────────────────────────────────────────
    var DEFAULTS = {
        fs: 0, lh: 0, spacing: 0, align: '', font: 0,
        contrast: '', saturation: '', gray: 0, noimg: 0, pause: 0,
        links: 0, mask: 0, guide: 0, cursor: 0, focus: 0, profile: '',
    };
    var PROFILES = {
        vision: { fs: 1.5, contrast: 'high', cursor: 1, focus: 1 },
        dyslexia: { font: 1, spacing: 1, lh: 1.6 },
        seizure: { pause: 1, saturation: 'low' },
        colorblind: { saturation: 'high', links: 1 },
        adhd: { mask: 1, pause: 1 },
    };
    // Valeurs admises par clé — le stockage est de la donnée non fiable
    // (corruption, extension, autre onglet) : tout ce qui n'est pas listé
    // retombe sur le défaut. Sans ça, un fs corrompu (ex. 99) zoomerait la
    // page ×99. Les clés absentes d'ALLOWED sont des booléens (0/1).
    var ALLOWED = {
        fs: [1.25, 1.5, 1.75, 2],
        lh: [1.3, 1.6, 2],
        align: ['left', 'right'],
        contrast: ['dark', 'light', 'high'],
        saturation: ['low', 'high'],
        profile: ['vision', 'dyslexia', 'seizure', 'colorblind', 'adhd'],
    };

    var state = load();

    function sanitize(key, value) {
        var allowed = ALLOWED[key];
        if (!allowed) return value ? 1 : 0;
        for (var i = 0; i < allowed.length; i++)
            if (String(allowed[i]) === String(value)) return allowed[i];
        return DEFAULTS[key];
    }

    function load() {
        var s = {};
        for (var k in DEFAULTS) s[k] = DEFAULTS[k];
        try {
            var raw = JSON.parse(localStorage.getItem(KEY) || 'null');
            if (raw && typeof raw === 'object')
                for (var k2 in DEFAULTS) if (k2 in raw) s[k2] = sanitize(k2, raw[k2]);
        } catch (e) { }
        return s;
    }
    function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { } }
    function resetState() {
        for (var k in DEFAULTS) state[k] = DEFAULTS[k];
        try { localStorage.removeItem(KEY); } catch (e) { }
    }
    function activeCount() {
        var n = 0;
        for (var k in DEFAULTS)
            if (k !== 'profile' && String(state[k]) !== String(DEFAULTS[k])) n++;
        return n;
    }

    // ── effects on <html> (inchangé depuis v1/v2, éprouvé par les tests) ──
    var maskEls = null, guideEl = null;

    function applyState(s) {
        var html = document.documentElement;

        try {
            var root = document.getElementById('pd-a11y-root');
            if ('zoom' in document.body.style) {
                document.body.style.zoom = s.fs ? String(s.fs) : '';
                if (root) root.style.zoom = s.fs ? String(1 / s.fs) : '';
            } else {
                html.style.fontSize = s.fs ? (s.fs * 100) + '%' : '';
            }
        } catch (e) { }

        toggle(html, 'pd-a11y-lh', !!s.lh);
        if (s.lh) html.style.setProperty('--pd-a11y-lh', String(s.lh)); else html.style.removeProperty('--pd-a11y-lh');

        toggle(html, 'pd-a11y-align', !!s.align);
        if (s.align) html.style.setProperty('--pd-a11y-align', s.align); else html.style.removeProperty('--pd-a11y-align');

        toggle(html, 'pd-a11y-spacing', !!s.spacing);
        toggle(html, 'pd-a11y-font', !!s.font);
        toggle(html, 'pd-a11y-noimg', !!s.noimg);
        toggle(html, 'pd-a11y-pause', !!s.pause);
        toggle(html, 'pd-a11y-links', !!s.links);
        toggle(html, 'pd-a11y-cursor', !!s.cursor);
        toggle(html, 'pd-a11y-focus', !!s.focus);
        toggle(html, 'pd-a11y-invert', s.contrast === 'dark');

        var f = [];
        if (s.contrast === 'dark') f.push('invert(1) hue-rotate(180deg)');
        else if (s.contrast === 'light') f.push('brightness(1.12) contrast(1.05)');
        else if (s.contrast === 'high') f.push('contrast(1.45)');
        if (s.saturation === 'low') f.push('saturate(0.4)');
        else if (s.saturation === 'high') f.push('saturate(2)');
        if (s.gray) f.push('grayscale(1)');
        html.style.filter = f.join(' ');

        if (s.pause) {
            var vids = document.querySelectorAll('video, audio');
            for (var i = 0; i < vids.length; i++) { try { vids[i].pause(); } catch (e) { } }
        }

        setMask(!!s.mask);
        setGuide(!!s.guide);
        // Le zoom a pu changer : replace masque et guide immédiatement
        // (leurs coordonnées dépendent du facteur de zoom du body).
        if (maskEls) maskEls.move({ clientY: maskEls.y });
        if (guideEl) guideEl.move({ clientY: guideEl.y });
        updateBadge();
    }

    function toggle(el, cls, on) { el.classList[on ? 'add' : 'remove'](cls); }

    /// Facteur de zoom courant du body (réglage « texte plus grand »).
    /// Masque et guide sont des enfants FIXES du body zoomé : leurs px de
    /// style sont multipliés par ce facteur au rendu — les coordonnées
    /// visées (clientY, en px réels du viewport) doivent donc être divisées.
    function pageZoom() {
        var z = parseFloat((document.body && document.body.style.zoom) || '1');
        return z > 0 ? z : 1;
    }

    function updateBadge() {
        var b = document.getElementById('pd-a11y-badge');
        var btn = document.getElementById('pd-a11y-btn');
        if (!b || !btn) return;
        var n = activeCount();
        b.textContent = n ? String(n) : '';
        b.hidden = !n;
        btn.setAttribute('aria-label', T.open + (n ? ' (' + n + ' ' + T.activeCount + ')' : ''));
    }

    function setMask(on) {
        if (on && !maskEls) {
            var top = document.createElement('div'), bottom = document.createElement('div');
            top.className = 'pd-a11y-mask pd-a11y-mask-top';
            bottom.className = 'pd-a11y-mask pd-a11y-mask-bottom';
            top.setAttribute('aria-hidden', 'true');
            bottom.setAttribute('aria-hidden', 'true');
            document.body.appendChild(top);
            document.body.appendChild(bottom);
            maskEls = { top: top, bottom: bottom, y: window.innerHeight / 2, raf: 0 };
            maskEls.move = function (ev) {
                maskEls.y = ev.clientY;
                if (!maskEls.raf) maskEls.raf = requestAnimationFrame(function () {
                    maskEls.raf = 0;
                    var band = 110, z = pageZoom();
                    maskEls.top.style.height = Math.max(0, (maskEls.y - band / 2) / z) + 'px';
                    maskEls.bottom.style.top = ((maskEls.y + band / 2) / z) + 'px';
                });
            };
            document.addEventListener('mousemove', maskEls.move, { passive: true });
            maskEls.move({ clientY: maskEls.y });
        } else if (!on && maskEls) {
            document.removeEventListener('mousemove', maskEls.move);
            if (maskEls.raf) cancelAnimationFrame(maskEls.raf);
            maskEls.top.remove(); maskEls.bottom.remove();
            maskEls = null;
        }
    }

    function setGuide(on) {
        if (on && !guideEl) {
            var g = document.createElement('div');
            g.className = 'pd-a11y-guideline';
            g.setAttribute('aria-hidden', 'true');
            document.body.appendChild(g);
            guideEl = { el: g, y: window.innerHeight / 2, raf: 0 };
            guideEl.move = function (ev) {
                guideEl.y = ev.clientY;
                if (!guideEl.raf) guideEl.raf = requestAnimationFrame(function () {
                    guideEl.raf = 0;
                    guideEl.el.style.top = ((guideEl.y + 14) / pageZoom()) + 'px';
                });
            };
            document.addEventListener('mousemove', guideEl.move, { passive: true });
            guideEl.move({ clientY: guideEl.y });
        } else if (!on && guideEl) {
            document.removeEventListener('mousemove', guideEl.move);
            if (guideEl.raf) cancelAnimationFrame(guideEl.raf);
            guideEl.el.remove();
            guideEl = null;
        }
    }

    // ── accent générique : contraste auto par luminance ──────────────
    function accentContrast(hex) {
        var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim());
        if (!m) return '#ffffff';
        var n = parseInt(m[1], 16);
        var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
        // luminance perceptuelle simple (sRGB approx.)
        var lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return lum > 0.6 ? '#0c0d0e' : '#ffffff';
    }

    // ── tuiles (grille type Ally : clic = cran suivant, points d'étape) ──
    var ICONS = {
        fs: '<path d="M4 18 9.5 5h1.8L17 18h-2.1l-1.4-3.4H7.3L5.9 18H4zm4-5.2h4.7L10.4 7 8 12.8zM17.5 9.5h2v-2h1.6v2h2v1.6h-2v2h-1.6v-2h-2V9.5z"/>',
        lh: '<path d="M4 5h10v1.7H4V5zm0 4.1h10v1.7H4V9.1zm0 4.1h10v1.7H4v-1.7zm0 4.1h10V19H4v-1.7zM18.6 5.5l2.9 3h-1.9v7h1.9l-2.9 3-2.9-3h1.9v-7h-1.9l2.9-3z"/>',
        spacing: '<path d="M9 5h1.7v14H9V5zm4.3 0H15v14h-1.7V5zM3.5 10.5 6 12l-2.5 1.5v-3zM20.5 10.5v3L18 12l2.5-1.5z"/>',
        align: '<path d="M4 5h16v1.7H4V5zm0 4.1h10v1.7H4V9.1zm0 4.1h16v1.7H4v-1.7zm0 4.1h10V19H4v-1.7z"/>',
        font: '<path d="M5 18 9.8 6h1.6L16 18h-1.9l-1.2-3.1H8.2L7 18H5zm3.8-4.7h3.5L10.6 8.6l-1.8 4.7zM17 18c.8-2.4 1.3-4.3 1.3-6s-.4-3.5-1.3-6h1.6c.9 2.4 1.4 4.4 1.4 6s-.5 3.6-1.4 6H17z"/>',
        contrast: '<path d="M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm0 1.8v14.4a7.2 7.2 0 0 0 0-14.4z"/>',
        saturation: '<path d="M12 3c4 4.5 6.4 7.5 6.4 10.8a6.4 6.4 0 1 1-12.8 0C5.6 10.5 8 7.5 12 3zm0 2.7c-3 3.5-4.6 5.9-4.6 8.1a4.6 4.6 0 0 0 4.6 4.7V5.7z"/>',
        gray: '<path d="M5 5h14v14H5V5zm1.7 1.7v10.6h5.1V6.7H6.7zm6.8 0v10.6h3.8V6.7h-3.8z" opacity=".85"/>',
        noimg: '<path d="M4 5h16v14H4V5zm1.7 1.7v9.1l3.6-3.6 2.6 2.6 4-4 2.4 2.4V6.7H5.7zM3.3 3.3l17.4 17.4-1.2 1.2L2.1 4.5l1.2-1.2z"/>',
        pause: '<path d="M8 5h3v14H8V5zm5 0h3v14h-3V5z"/>',
        links: '<path d="M10.6 13.4a4 4 0 0 1 0-5.7l2.8-2.8a4 4 0 1 1 5.7 5.7l-1.5 1.5-1.2-1.2 1.5-1.5a2.3 2.3 0 1 0-3.3-3.3l-2.8 2.8c-.9.9-.9 2.4 0 3.3l-1.2 1.2zm2.8-2.8a4 4 0 0 1 0 5.7l-2.8 2.8a4 4 0 1 1-5.7-5.7l1.5-1.5 1.2 1.2-1.5 1.5a2.3 2.3 0 1 0 3.3 3.3l2.8-2.8c.9-.9.9-2.4 0-3.3l1.2-1.2z"/>',
        mask: '<path d="M3 4h18v6H3V4zm0 10h18v6H3v-6zm1.7 1.7v2.6h14.6v-2.6H4.7z" opacity=".9"/>',
        guide: '<path d="M3 11h18v2H3v-2zm2-5h14v1.7H5V6zm0 10.3h14V18H5v-1.7z" opacity=".9"/>',
        cursor: '<path d="M6 3.5 19 15l-5.6.6 3.1 6-2.7 1.3-3-6.1-4 3.7L6 3.5z"/>',
        focus: '<path d="M4 4h5v1.8H5.8V9H4V4zm11 0h5v5h-1.8V5.8H15V4zM4 15h1.8v3.2H9V20H4v-5zm14.2 0H20v5h-5v-1.8h3.2V15zM9 9h6v6H9V9z"/>',
    };
    // steps: null = simple bascule ; sinon crans successifs [valeur, libellé]
    function tileDefs() {
        return {
            text: [
                { key: 'fs', label: T.bigger, steps: [[1.25, '1,25×'], [1.5, '1,5×'], [1.75, '1,75×'], [2, '2×']] },
                { key: 'lh', label: T.lineHeight, steps: [[1.3, '1,3×'], [1.6, '1,6×'], [2, '2×']] },
                { key: 'spacing', label: T.spacing },
                { key: 'align', label: T.align, steps: [['left', T.alignLeft], ['right', T.alignRight]] },
                { key: 'font', label: T.font },
            ],
            visual: [
                { key: 'contrast', label: T.contrast, steps: [['dark', T.dark], ['light', T.light], ['high', T.high]] },
                { key: 'saturation', label: T.saturation, steps: [['low', T.satLow], ['high', T.satHigh]] },
                { key: 'gray', label: T.gray },
                { key: 'noimg', label: T.noimg },
                { key: 'pause', label: T.pause },
            ],
            orientation: [
                { key: 'links', label: T.links },
                { key: 'mask', label: T.mask },
                { key: 'guide', label: T.guide },
                { key: 'cursor', label: T.cursor },
                { key: 'focus', label: T.focus },
            ],
        };
    }
    var TILE_STEPS = {}; // key → steps (rempli au rendu, utilisé au clic)

    // ── init ──────────────────────────────────────────────────────────
    function init() {
        var cfg = window.__pdA11yConfig;
        if (!cfg || !cfg.enabled) return;
        if (document.getElementById('pd-a11y-root')) return;

        try {
            var hiddenUntil = parseInt(localStorage.getItem(HIDE_KEY) || '0', 10);
            if (hiddenUntil && Date.now() < hiddenUntil) { applyState(state); return; }
        } catch (e) { }

        build(cfg);
    }

    // ── UI ────────────────────────────────────────────────────────────
    var altHandler = null, openerHandler = null;

    function build(cfg) {
        var accent = /^#[0-9a-f]{6}$/i.test(String(cfg.color || '')) ? cfg.color : '#1f2937';
        injectCss();

        var pos = String(cfg.position || 'bottom-left');
        if (['bottom-left', 'bottom-right', 'top-left', 'top-right'].indexOf(pos) < 0) pos = 'bottom-left';
        var size = { small: 36, medium: 44, large: 56 }[String(cfg.size || 'medium')] || 44;
        var hiddenMode = String(cfg.mode || 'live') === 'hidden';

        var root = document.createElement('div');
        root.id = 'pd-a11y-root';
        root.className = 'pd-a11y-' + pos + (hiddenMode ? ' pd-a11y-nobtn' : '');
        root.style.setProperty('--pd-a11y-accent', accent);
        root.style.setProperty('--pd-a11y-accent-contrast', accentContrast(accent));
        root.style.setProperty('--pd-a11y-btn-size', size + 'px');

        var live = document.createElement('div');
        live.id = 'pd-a11y-live';
        live.setAttribute('aria-live', 'polite');
        live.className = 'pd-a11y-sr';

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.id = 'pd-a11y-btn';
        btn.setAttribute('aria-label', T.open);
        btn.setAttribute('aria-haspopup', 'dialog');
        btn.setAttribute('aria-expanded', 'false');
        if (hiddenMode) btn.classList.add('pd-a11y-sr'); // mode masqué : bouton hors écran mais focusable au clavier
        btn.innerHTML =
            '<span class="pd-a11y-btn-ring" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor" focusable="false">' +
            '<path d="M12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm9 5.5c.3 0 .5.2.5.5s-.2.5-.5.5c-2.4.3-4.8.5-7.2.6l.4 4.4 2.3 7.4a1 1 0 0 1-1.9.7l-2.3-6.9h-.6l-2.3 6.9a1 1 0 0 1-1.9-.7l2.3-7.4.4-4.4c-2.4-.1-4.8-.3-7.2-.6a.5.5 0 0 1 0-1h.1c3 .4 6 .6 8.9.6s5.9-.2 8.9-.6h.1z"/>' +
            '</svg></span>' +
            '<span id="pd-a11y-badge" aria-hidden="true" hidden></span>';

        var panel = document.createElement('div');
        panel.id = 'pd-a11y-panel';
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        panel.setAttribute('aria-labelledby', 'pd-a11y-title');
        panel.hidden = true;

        var defs = tileDefs();
        TILE_STEPS = {};
        var otherLang = lang() === 'fr' ? 'en' : 'fr';
        panel.innerHTML =
            '<div class="pd-a11y-head">' +
            '  <h2 id="pd-a11y-title">' + T.title + '</h2>' +
            '  <span class="pd-a11y-head-actions">' +
            '    <button type="button" class="pd-a11y-langbtn" data-a11y-lang="' + otherLang + '" aria-label="' + (otherLang === 'en' ? 'Switch to English' : 'Passer en français') + '">' + otherLang.toUpperCase() + '</button>' +
            '    <button type="button" class="pd-a11y-x" data-a11y-close aria-label="' + T.close + '">&#10005;</button>' +
            '  </span>' +
            '</div>' +
            '<div class="pd-a11y-body" id="pd-a11y-main">' +
            '<section class="pd-a11y-sec"><h3>' + T.profiles + '</h3><div class="pd-a11y-profiles">' +
            chip('vision', T.pVision) + chip('dyslexia', T.pDyslexia) + chip('seizure', T.pSeizure) +
            chip('colorblind', T.pColorblind) + chip('adhd', T.pAdhd) +
            '</div></section>' +
            section(T.text, tiles(defs.text)) +
            section(T.visual, tiles(defs.visual)) +
            section(T.orientation, tiles(defs.orientation) +
                '<div class="pd-a11y-navrow"><button type="button" class="pd-a11y-nav" data-a11y-structure>' + T.structure + ' <span aria-hidden="true">&#8250;</span></button>' +
                (cfg.sitemapUrl ? '<a class="pd-a11y-nav" href="' + escAttr(cfg.sitemapUrl) + '">' + T.sitemap + ' <span aria-hidden="true">&#8250;</span></a>' : '') +
                '</div>') +
            '</div>' +
            '<div class="pd-a11y-body" id="pd-a11y-structure" hidden>' +
            '  <button type="button" class="pd-a11y-nav pd-a11y-back" data-a11y-back><span aria-hidden="true">&#8249;</span> ' + T.back + '</button>' +
            '  <ul class="pd-a11y-headings"></ul>' +
            '</div>' +
            '<div class="pd-a11y-foot">' +
            '  <button type="button" class="pd-a11y-ghost" data-a11y-reset>' + T.reset + '</button>' +
            '  <button type="button" class="pd-a11y-ghost" data-a11y-hide>' + T.hide + '</button>' +
            '  <span class="pd-a11y-kbd" aria-hidden="true">' + T.shortcut + '</span>' +
            (cfg.statementUrl ? '  <a class="pd-a11y-statement" href="' + escAttr(cfg.statementUrl) + '">' + T.statement + '</a>' : '') +
            '</div>';

        root.appendChild(live);
        root.appendChild(panel);
        root.appendChild(btn);
        document.body.appendChild(root);

        // ── wiring ──
        var lastFocus = null;

        function openPanel() {
            panel.hidden = false;
            btn.setAttribute('aria-expanded', 'true');
            lastFocus = document.activeElement;
            refresh();
            showMain();
            var first = panel.querySelector('.pd-a11y-x');
            if (first) first.focus();
        }
        function closePanel() {
            panel.hidden = true;
            btn.setAttribute('aria-expanded', 'false');
            if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus(); else btn.focus();
        }
        function showMain() {
            panel.querySelector('#pd-a11y-main').hidden = false;
            panel.querySelector('#pd-a11y-structure').hidden = true;
        }
        function announce(label, detail) {
            live.textContent = label + ' : ' + detail;
        }

        btn.addEventListener('click', function () { panel.hidden ? openPanel() : closePanel(); });

        // Raccourci global Alt+A. Listener unique — le rebuild (langue) le
        // remplace, sinon les handlers s'empilent sur un panneau retiré du DOM.
        if (altHandler) document.removeEventListener('keydown', altHandler);
        altHandler = function (ev) {
            if (ev.altKey && !ev.ctrlKey && !ev.metaKey && (ev.key === 'a' || ev.key === 'A' || ev.code === 'KeyA')) {
                if (!document.getElementById('pd-a11y-root')) return;
                ev.preventDefault();
                panel.hidden ? openPanel() : closePanel();
            }
        };
        document.addEventListener('keydown', altHandler);

        // Ouverture depuis le site : tout élément [data-pd-a11y] (lien footer,
        // bouton du thème…) ouvre le panneau — utile surtout en mode masqué.
        if (openerHandler) document.removeEventListener('click', openerHandler);
        openerHandler = function (ev) {
            var t = ev.target && ev.target.closest ? ev.target.closest('[data-pd-a11y]') : null;
            if (!t || !document.getElementById('pd-a11y-root')) return;
            ev.preventDefault();
            openPanel();
        };
        document.addEventListener('click', openerHandler);

        panel.addEventListener('click', function (ev) {
            var t = ev.target.closest ? ev.target.closest('button,a') : null;
            if (!t) return;

            if (t.hasAttribute('data-a11y-close')) { closePanel(); return; }
            if (t.hasAttribute('data-a11y-back')) { showMain(); panel.querySelector('[data-a11y-structure]').focus(); return; }

            if (t.hasAttribute('data-a11y-lang')) {
                try { localStorage.setItem(LANG_KEY, t.getAttribute('data-a11y-lang')); } catch (e) { }
                T = STRINGS[lang()];
                root.remove();
                build(cfg);
                var reopened = document.getElementById('pd-a11y-btn');
                if (reopened) reopened.click();
                return;
            }

            if (t.hasAttribute('data-a11y-structure')) {
                buildHeadings();
                panel.querySelector('#pd-a11y-main').hidden = true;
                var st = panel.querySelector('#pd-a11y-structure');
                st.hidden = false;
                st.querySelector('.pd-a11y-back').focus();
                return;
            }

            if (t.hasAttribute('data-a11y-reset')) {
                resetState();
                applyState(state);
                refresh();
                announce(T.reset, T.on);
                return;
            }

            if (t.hasAttribute('data-a11y-hide')) {
                if (t.getAttribute('data-armed') === '1') {
                    try { localStorage.setItem(HIDE_KEY, String(Date.now() + 24 * 3600 * 1000)); } catch (e) { }
                    closePanel();
                    root.remove();
                } else {
                    t.setAttribute('data-armed', '1');
                    t.textContent = T.hideConfirm;
                    setTimeout(function () { t.removeAttribute('data-armed'); t.textContent = T.hide; }, 3000);
                }
                return;
            }

            var profile = t.getAttribute('data-a11y-profile');
            if (profile) {
                var wasActive = state.profile === profile;
                resetState();
                if (!wasActive) {
                    var set = PROFILES[profile] || {};
                    for (var pk in set) state[pk] = set[pk];
                    state.profile = profile;
                    save();
                }
                applyState(state);
                refresh();
                announce(t.textContent, wasActive ? T.off : T.on);
                return;
            }

            var key = t.getAttribute('data-a11y-tile');
            if (key) {
                var steps = TILE_STEPS[key];
                var label = t.querySelector('.pd-a11y-tlabel').textContent;
                if (steps) {
                    // cran suivant : défaut → 1er → … → dernier → défaut
                    var idx = -1;
                    for (var i = 0; i < steps.length; i++)
                        if (String(steps[i][0]) === String(state[key])) { idx = i; break; }
                    var next = idx + 1;
                    state[key] = next >= steps.length ? DEFAULTS[key] : steps[next][0];
                    announce(label, next >= steps.length ? T.off : steps[next][1]);
                } else {
                    state[key] = state[key] ? 0 : 1;
                    announce(label, state[key] ? T.on : T.off);
                }
                save();
                applyState(state);
                refresh();
            }
        });

        panel.addEventListener('keydown', function (ev) {
            if (ev.key === 'Escape') { ev.stopPropagation(); closePanel(); return; }
            if (ev.key !== 'Tab') return;
            var focusables = panel.querySelectorAll('button:not([hidden]), a[href]');
            var list = [];
            for (var i = 0; i < focusables.length; i++)
                if (focusables[i].offsetParent !== null) list.push(focusables[i]);
            if (!list.length) return;
            var first = list[0], last = list[list.length - 1];
            if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
            else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
        });

        function refresh() {
            var controls = panel.querySelectorAll('[data-a11y-tile]');
            for (var i = 0; i < controls.length; i++) {
                var c = controls[i];
                var key = c.getAttribute('data-a11y-tile');
                var steps = TILE_STEPS[key];
                var label = c.querySelector('.pd-a11y-tlabel').textContent;
                var active = String(state[key]) !== String(DEFAULTS[key]);
                c.setAttribute('aria-pressed', active ? 'true' : 'false');
                c.classList[active ? 'add' : 'remove']('pd-a11y-on');
                if (steps) {
                    var idx = -1;
                    for (var j = 0; j < steps.length; j++)
                        if (String(steps[j][0]) === String(state[key])) { idx = j; break; }
                    var dots = c.querySelectorAll('.pd-a11y-dots i');
                    for (var d = 0; d < dots.length; d++)
                        dots[d].className = d <= idx ? 'pd-a11y-dot-on' : '';
                    var chipEl = c.querySelector('.pd-a11y-tval');
                    chipEl.textContent = idx >= 0 ? steps[idx][1] : '';
                    chipEl.hidden = idx < 0;
                    c.setAttribute('aria-label', label + (idx >= 0 ? ' : ' + steps[idx][1] : ' : ' + T.off));
                }
            }
            var cards = panel.querySelectorAll('[data-a11y-profile]');
            for (var k = 0; k < cards.length; k++) {
                var on = state.profile === cards[k].getAttribute('data-a11y-profile');
                cards[k].setAttribute('aria-pressed', on ? 'true' : 'false');
                cards[k].classList[on ? 'add' : 'remove']('pd-a11y-on');
            }
            updateBadge();
        }

        function buildHeadings() {
            var ul = panel.querySelector('.pd-a11y-headings');
            ul.innerHTML = '';
            var hs = document.querySelectorAll('h1,h2,h3,h4,h5,h6');
            var count = 0;
            for (var i = 0; i < hs.length; i++) {
                var h = hs[i];
                if (root.contains(h)) continue;
                var txt = (h.textContent || '').replace(/\s+/g, ' ').trim();
                if (!txt) continue;
                count++;
                var li = document.createElement('li');
                var lvl = parseInt(h.tagName.substring(1), 10);
                li.style.paddingLeft = ((lvl - 1) * 14) + 'px';
                var a = document.createElement('button');
                a.type = 'button';
                a.className = 'pd-a11y-hlink';
                a.textContent = txt.length > 70 ? txt.slice(0, 70) + '…' : txt;
                (function (target) {
                    a.addEventListener('click', function () {
                        target.scrollIntoView({ block: 'start' });
                        target.setAttribute('tabindex', '-1');
                        try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
                    });
                })(h);
                li.appendChild(a);
                ul.appendChild(li);
            }
            if (!count) {
                var empty = document.createElement('li');
                empty.className = 'pd-a11y-empty';
                empty.textContent = T.structureEmpty;
                ul.appendChild(empty);
            }
        }

        applyState(state);
        refresh();
        avoidCollisions(root, btn);
        window.PdA11y = {
            open: openPanel,
            close: closePanel,
            reset: function () { resetState(); applyState(state); },
        };
    }

    /// Anti-chevauchement générique : d'autres boutons flottants occupent
    /// souvent le même coin (bandeau cookies palladium-cookies, WhatsApp,
    /// chat tiers…). On sonde le centre du bouton avec elementsFromPoint ;
    /// si un élément FIXE étranger le recouvre, le widget se décale
    /// verticalement (au-dessus en bas d'écran, en dessous en haut) de la
    /// hauteur du bloqueur + 10 px, puis re-sonde (3 essais max). Re-vérifié
    /// à retardement : les widgets tiers se chargent en asynchrone.
    function avoidCollisions(root, btn) {
        if (btn.classList.contains('pd-a11y-sr')) return; // mode masqué : rien à éviter
        var attempts = 0;
        function probe() {
            if (!document.contains(btn) || attempts >= 3) return;
            var r = btn.getBoundingClientRect();
            if (!r.width) return;
            var els = document.elementsFromPoint(r.left + r.width / 2, r.top + r.height / 2);
            var blocker = null;
            for (var i = 0; i < els.length; i++) {
                var el = els[i];
                if (root.contains(el) || el === document.documentElement || el === document.body) continue;
                // remonte jusqu'à l'ancêtre positionné fixe (le bouton tiers lui-même)
                var p = el, fixedEl = null;
                while (p && p !== document.body) {
                    if (getComputedStyle(p).position === 'fixed') { fixedEl = p; break; }
                    p = p.parentElement;
                }
                if (!fixedEl) continue;
                // Seuls les PETITS éléments flottants comptent (bouton cookies,
                // chat…). Les grands fixes — écran de chargement plein viewport,
                // modales, bandeaux — sont transitoires ou traversés : les compter
                // envoyait le widget hors écran (loader inset:0 → +910 px).
                var br = fixedEl.getBoundingClientRect();
                if (br.width > 200 || br.height > 200) continue;
                blocker = fixedEl;
                break;
            }
            if (!blocker) return;
            attempts++;
            var current = parseFloat(root.style.getPropertyValue('--pd-a11y-shift')) || 0;
            var bump = (blocker.getBoundingClientRect().height || 48) + 10;
            if (current + bump > 240) return; // garde-fou : jamais loin du coin
            root.style.setProperty('--pd-a11y-shift', (current + bump) + 'px');
            requestAnimationFrame(probe);
        }
        probe();
        // les widgets tiers (cookies…) apparaissent après coup
        setTimeout(probe, 900);
        setTimeout(probe, 2600);
    }

    // helpers de gabarit
    function section(title, inner) {
        return '<section class="pd-a11y-sec"><h3>' + title + '</h3>' + inner + '</section>';
    }
    function chip(key, name) {
        return '<button type="button" class="pd-a11y-chip" data-a11y-profile="' + key + '" aria-pressed="false">' + name + '</button>';
    }
    function tiles(defs) {
        var out = '<div class="pd-a11y-grid">';
        for (var i = 0; i < defs.length; i++) {
            var d = defs[i];
            if (d.steps) TILE_STEPS[d.key] = d.steps;
            var dots = '';
            if (d.steps) {
                dots = '<span class="pd-a11y-dots" aria-hidden="true">';
                for (var j = 0; j < d.steps.length; j++) dots += '<i></i>';
                dots += '</span>';
            }
            out += '<button type="button" class="pd-a11y-tile" data-a11y-tile="' + d.key + '" aria-pressed="false">' +
                '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">' + (ICONS[d.key] || '') + '</svg>' +
                '<span class="pd-a11y-tlabel">' + d.label + '</span>' +
                (d.steps ? '<span class="pd-a11y-tval" hidden></span>' : '') +
                dots +
                '</button>';
        }
        return out + '</div>';
    }
    function escAttr(s) {
        return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    }

    function injectCss() {
        if (document.getElementById('pd-a11y-style')) return;
        var cursorArrow = 'url("data:image/svg+xml,' + encodeURIComponent(
            '<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 24 24">' +
            '<path d="M5.2 2.8l13 12-5.6.6 3.2 6.3-2.9 1.4-3.1-6.4-4.1 3.8z" fill="#111" stroke="#fff" stroke-width="1.4"/></svg>'
        ) + '") 5 3, auto';
        var css =
            /* ── effets de page ── */
            'html.pd-a11y-lh body *:not(#pd-a11y-root):not(#pd-a11y-root *){line-height:var(--pd-a11y-lh)!important}' +
            'html.pd-a11y-align body :is(p,li,h1,h2,h3,h4,h5,h6,blockquote,figcaption,dd,dt):not(#pd-a11y-root *){text-align:var(--pd-a11y-align)!important}' +
            'html.pd-a11y-spacing body *:not(#pd-a11y-root):not(#pd-a11y-root *){letter-spacing:.12em!important;word-spacing:.18em!important}' +
            'html.pd-a11y-font body *:not(#pd-a11y-root *):not(i):not(.fa):not([class*="fa-"]):not([class*="icon"]):not([class*="iconify"]):not([class*="material-"]){font-family:Verdana,"Trebuchet MS",Arial,Helvetica,sans-serif!important;letter-spacing:.02em!important;word-spacing:.08em!important}' +
            'html.pd-a11y-invert :is(img,picture,video,iframe,canvas,embed,object){filter:invert(1) hue-rotate(180deg)}' +
            'html.pd-a11y-invert #pd-a11y-root{filter:invert(1) hue-rotate(180deg)}' +
            'html.pd-a11y-noimg body :is(img,picture,video,figure,svg):not(#pd-a11y-root *){visibility:hidden!important}' +
            'html.pd-a11y-noimg body *:not(#pd-a11y-root):not(#pd-a11y-root *){background-image:none!important}' +
            /* pause : le widget s'exempte lui-même — sinon sa propre animation
               d'ouverture (pd-a11y-pop) reste figée à opacity:0 et le panneau
               devient impossible à rouvrir (bug profil Concentration). */
            'html.pd-a11y-pause *:not(#pd-a11y-root):not(#pd-a11y-root *),html.pd-a11y-pause *:not(#pd-a11y-root):not(#pd-a11y-root *)::before,html.pd-a11y-pause *:not(#pd-a11y-root):not(#pd-a11y-root *)::after{animation-play-state:paused!important;transition:none!important;scroll-behavior:auto!important}' +
            'html.pd-a11y-links body a:not(#pd-a11y-root a){background:#ffe45c!important;color:#0a0a0a!important;text-decoration:underline!important;box-shadow:0 0 0 2px #ffe45c!important}' +
            'html.pd-a11y-cursor,html.pd-a11y-cursor *{cursor:' + cursorArrow + '!important}' +
            'html.pd-a11y-focus :focus{outline:4px solid #e67e00!important;outline-offset:2px!important}' +
            /* ── masque + guide ── */
            '.pd-a11y-mask{position:fixed;left:0;right:0;background:rgba(6,10,18,.55);z-index:2147482000;pointer-events:none}' +
            '.pd-a11y-mask-top{top:0;height:0}' +
            '.pd-a11y-mask-bottom{bottom:0;top:60%}' +
            '.pd-a11y-guideline{position:fixed;left:0;right:0;height:9px;background:var(--pd-a11y-accent,#1f2937);border-top:2px solid #fff;border-bottom:2px solid #fff;opacity:.85;z-index:2147482100;pointer-events:none}' +
            /* ── racine, accent générique ── */
            '#pd-a11y-root{position:fixed;z-index:2147483000;font:400 13.5px/1.45 ui-sans-serif,system-ui,Segoe UI,Roboto,Arial,sans-serif;color:#0c0d0e;' +
            '--pd-a11y-a:var(--pd-a11y-accent,#1f2937);--pd-a11y-c:var(--pd-a11y-accent-contrast,#fff)}' +
            /* --pd-a11y-shift : décalage anti-chevauchement (voir avoidCollisions) */
            '#pd-a11y-root.pd-a11y-bottom-left{left:16px;bottom:calc(16px + var(--pd-a11y-shift,0px))}' +
            '#pd-a11y-root.pd-a11y-bottom-right{right:16px;bottom:calc(16px + var(--pd-a11y-shift,0px))}' +
            '#pd-a11y-root.pd-a11y-top-left{left:16px;top:calc(16px + var(--pd-a11y-shift,0px))}' +
            '#pd-a11y-root.pd-a11y-top-right{right:16px;top:calc(16px + var(--pd-a11y-shift,0px))}' +
            '.pd-a11y-sr{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}' +
            /* ── bouton discret type Ally : cercle accent + anneau ── */
            '#pd-a11y-btn{position:relative;width:var(--pd-a11y-btn-size,44px);height:var(--pd-a11y-btn-size,44px);border-radius:50%;border:0;cursor:pointer;background:var(--pd-a11y-a);color:var(--pd-a11y-c);display:flex;align-items:center;justify-content:center;box-shadow:0 3px 12px rgba(6,20,50,.28);transition:transform .2s ease}' +
            '#pd-a11y-btn:hover{transform:scale(1.08)}' +
            '#pd-a11y-btn:focus-visible{outline:none;box-shadow:0 0 0 2px #015fcc,0 0 0 4px #fff}' +
            '.pd-a11y-btn-ring{box-sizing:border-box;width:68%;height:68%;display:flex;align-items:center;justify-content:center;border:1.5px solid var(--pd-a11y-c);border-radius:50%}' +
            '.pd-a11y-btn-ring svg{width:72%;height:72%}' +
            '#pd-a11y-badge{position:absolute;top:-3px;right:-3px;min-width:17px;height:17px;border-radius:9px;background:#e8443a;color:#fff;font:700 10.5px/17px ui-sans-serif,system-ui,sans-serif;text-align:center;padding:0 4px;box-shadow:0 0 0 2px #fff}' +
            '#pd-a11y-badge[hidden]{display:none!important}' +
            /* mode masqué : la règle #id de taille bat .pd-a11y-sr → version qualifiée */
            '#pd-a11y-btn.pd-a11y-sr{width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);position:absolute;box-shadow:none;transform:none}' +
            /* ── panneau : radius asymétrique + en-tête accent (réf. Ally) ── */
            '#pd-a11y-panel{position:absolute;width:400px;max-width:calc(100vw - 24px);max-height:min(82vh,680px);display:flex;flex-direction:column;background:#fff;border-radius:12px 12px 22px 22px;box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14);overflow:hidden}' +
            /* display:flex sur #id battrait la règle UA [hidden] */
            '#pd-a11y-panel[hidden],#pd-a11y-main[hidden],#pd-a11y-structure[hidden]{display:none!important}' +
            '@media (prefers-reduced-motion:no-preference){#pd-a11y-panel{animation:pd-a11y-pop .18s ease}}' +
            '@keyframes pd-a11y-pop{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}' +
            '.pd-a11y-bottom-left #pd-a11y-panel{left:0;bottom:calc(var(--pd-a11y-btn-size,44px) + 12px)}' +
            '.pd-a11y-bottom-right #pd-a11y-panel{right:0;bottom:calc(var(--pd-a11y-btn-size,44px) + 12px)}' +
            '.pd-a11y-top-left #pd-a11y-panel{left:0;top:calc(var(--pd-a11y-btn-size,44px) + 12px)}' +
            '.pd-a11y-top-right #pd-a11y-panel{right:0;top:calc(var(--pd-a11y-btn-size,44px) + 12px)}' +
            /* mode masqué : le panneau s'ancre au coin, pas au bouton */
            '.pd-a11y-nobtn #pd-a11y-panel{bottom:0;top:auto}' +
            '.pd-a11y-top-left.pd-a11y-nobtn #pd-a11y-panel,.pd-a11y-top-right.pd-a11y-nobtn #pd-a11y-panel{top:0;bottom:auto}' +
            '.pd-a11y-head{display:flex;align-items:center;justify-content:space-between;padding:12px 14px;background:var(--pd-a11y-a);color:var(--pd-a11y-c);border-radius:0 0 13px 13px}' +
            '.pd-a11y-head h2{margin:0;font-size:15px;font-weight:600;color:var(--pd-a11y-c)}' +
            '.pd-a11y-head-actions{display:inline-flex;align-items:center;gap:6px}' +
            '.pd-a11y-langbtn{border:1px solid color-mix(in srgb,var(--pd-a11y-c) 55%,transparent);background:transparent;color:var(--pd-a11y-c);font-size:11px;font-weight:700;border-radius:6px;padding:2px 6px;cursor:pointer}' +
            '.pd-a11y-langbtn:focus-visible{outline:2px solid #ffbf00}' +
            '.pd-a11y-x{border:0;background:transparent;color:var(--pd-a11y-c);font-size:14px;cursor:pointer;padding:4px 6px;border-radius:6px}' +
            '.pd-a11y-x:focus-visible{outline:2px solid #ffbf00}' +
            '.pd-a11y-body{overflow-y:auto;padding:6px 14px 12px;flex:1;scrollbar-width:thin}' +
            '.pd-a11y-sec h3{margin:12px 2px 7px;font-size:11px;font-weight:700;letter-spacing:.07em;text-transform:uppercase;color:#69727d}' +
            /* profils : puces compactes */
            '.pd-a11y-profiles{display:flex;flex-wrap:wrap;gap:6px}' +
            '.pd-a11y-chip{border:1px solid #d0d5dd;background:#f9fafb;color:#0c0d0e;border-radius:16px;padding:5px 11px;font-size:12.5px;cursor:pointer}' +
            '.pd-a11y-chip.pd-a11y-on{background:var(--pd-a11y-a);border-color:var(--pd-a11y-a);color:var(--pd-a11y-c)}' +
            '.pd-a11y-chip:focus-visible{outline:2px solid #ffbf00;outline-offset:1px}' +
            /* tuiles (réf. Ally) : grille 2 col, icône + libellé + points d'étape */
            '.pd-a11y-grid{display:grid;grid-template-columns:1fr 1fr;gap:7px}' +
            '.pd-a11y-tile{position:relative;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:5px;min-height:74px;border:1px solid #d0d5dd;background:#fff;border-radius:10px;padding:10px 8px 12px;cursor:pointer;color:#0c0d0e;text-align:center;transition:border-color .15s,background .15s}' +
            '.pd-a11y-tile svg{width:21px;height:21px;color:#515962}' +
            '.pd-a11y-tile .pd-a11y-tlabel{font-size:12.3px;line-height:1.25}' +
            '.pd-a11y-tile .pd-a11y-tval{position:absolute;top:5px;right:6px;font-size:10px;font-weight:700;color:var(--pd-a11y-a);background:color-mix(in srgb,var(--pd-a11y-a) 12%,#fff);border-radius:8px;padding:1px 5px}' +
            '.pd-a11y-tile .pd-a11y-tval[hidden]{display:none!important}' +
            '.pd-a11y-tile .pd-a11y-dots{position:absolute;bottom:5px;display:flex;gap:3px}' +
            '.pd-a11y-tile .pd-a11y-dots i{width:5px;height:5px;border-radius:50%;background:#d0d5dd}' +
            '.pd-a11y-tile .pd-a11y-dots i.pd-a11y-dot-on{background:var(--pd-a11y-a)}' +
            '.pd-a11y-tile:hover{border-color:#9da5ae}' +
            '.pd-a11y-tile.pd-a11y-on{border-color:var(--pd-a11y-a);background:color-mix(in srgb,var(--pd-a11y-a) 7%,#fff);box-shadow:inset 0 0 0 1px var(--pd-a11y-a)}' +
            '.pd-a11y-tile.pd-a11y-on svg{color:var(--pd-a11y-a)}' +
            '.pd-a11y-tile:focus-visible{outline:2px solid #ffbf00;outline-offset:1px}' +
            /* navigation + structure */
            '.pd-a11y-navrow{display:flex;flex-direction:column;gap:6px;margin-top:8px}' +
            '.pd-a11y-nav{display:flex;align-items:center;justify-content:space-between;width:100%;border:1px solid #d0d5dd;background:#f9fafb;border-radius:8px;padding:7px 10px;font-size:13px;cursor:pointer;color:#0c0d0e;text-decoration:none;box-sizing:border-box}' +
            '.pd-a11y-nav:focus-visible{outline:2px solid #ffbf00}' +
            '.pd-a11y-back{margin:6px 0 8px;justify-content:flex-start;gap:6px}' +
            '.pd-a11y-headings{list-style:none;margin:0;padding:0}' +
            '.pd-a11y-headings li{margin:2px 0}' +
            '.pd-a11y-hlink{border:0;background:transparent;cursor:pointer;font-size:13px;color:#0c5fcc;text-decoration:underline;text-align:left;padding:3px 2px}' +
            '.pd-a11y-hlink:focus-visible{outline:2px solid #ffbf00}' +
            '.pd-a11y-empty{color:#69727d;font-size:13px;padding:4px 2px}' +
            /* pied */
            '.pd-a11y-foot{display:flex;align-items:center;gap:8px;flex-wrap:wrap;padding:9px 14px;border-top:1px solid #e6e9ee;background:#f9fafb}' +
            '.pd-a11y-ghost{border:1px solid #d0d5dd;background:#fff;border-radius:8px;padding:4px 9px;font-size:12px;cursor:pointer;color:#0c0d0e}' +
            '.pd-a11y-ghost:focus-visible{outline:2px solid #ffbf00}' +
            '.pd-a11y-kbd{font-size:10.5px;color:#69727d;border:1px solid #d0d5dd;border-radius:5px;padding:1px 5px;background:#fff}' +
            '.pd-a11y-statement{margin-left:auto;font-size:11.5px;color:#0c5fcc}' +
            /* mobile : bottom-sheet (réf. Ally < 530px) */
            '@media (max-width:530px){#pd-a11y-panel{position:fixed!important;left:0!important;right:0!important;bottom:0!important;top:auto!important;width:100%;max-width:100%;max-height:72vh;border-radius:12px 12px 0 0}}' +
            '@media print{#pd-a11y-root,.pd-a11y-mask,.pd-a11y-guideline{display:none!important}}';
        var st = document.createElement('style');
        st.id = 'pd-a11y-style';
        st.textContent = css;
        document.head.appendChild(st);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
